import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Col } from "shards-react";

import SidebarMainNavbar from "./SidebarMainNavbar";
import SidebarNavItems from "./SidebarNavItems";
import { Store } from "../../../flux";
import storeHelper from "../../../flux/storeHelper";
import { useSelector } from "react-redux";

export const MainSidebar = (props) => {
    
    const [menuVisible, setMenuVisible] = useState(false);
    const { user } = useSelector(state => state.user);

    const _store = storeHelper(user.roles[0].name);
    
    const [sidebarNavItems, setSidebarNavItems] = useState(_store);    
        
    const onChange = () => {

        setMenuVisible(Store.getMenuState())
        // setMenuVisible(_store.menuVisible)
        // setSidebarNavItems(Store.getSidebarItems());
        setSidebarNavItems(_store.navItems);
        
    }

    useEffect( () => {
        // Anything here is fired on component mount.
        Store.addChangeListener( () => { onChange() } );
        return () => {
            // Anything here is fired on component unmount.
            Store.removeChangeListener( () => { onChange() } );
        }
    }, []);

    const classes = classNames(
        "main-sidebar",
        "px-0",
        "col-12",
        menuVisible && "open"
    );
    
    return (
        <Col
            tag="aside"
            className={classes}
            lg={{ size: 2 }}
            md={{ size: 3 }}
        >
            <SidebarMainNavbar hideLogoText={ props.hideLogoText } />
            <SidebarNavItems _store={_store} />
        </Col>
    );
}

MainSidebar.propTypes = {
    t: PropTypes.func
};

export default MainSidebar;
